<template>
  <div class="productInfos">
    <productInfo :dataList="dataList"></productInfo>
  </div>
</template>

<script>
import productInfo from "@/components/productInfo";
export default {
  data() {
    return {
      dataList: [],
    };
  },
  components: {
    productInfo,
  },
  created() {
    this.dataList = this.$route.query.dataList;
  },
  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped></style>
